import * as yup from 'yup';
import { StatRingOverlay } from '@web/components';

export const component = StatRingOverlay;

export const schema = yup
  .object({
    statName: yup.string(),
    pillText: yup.string(),
    score: yup.number(),
    circleFillColor: yup.string(),
    circleBackgroundColor: yup.string(),
    pillColor: yup.string(),
    mobileAlignment: yup.string(),
    desktopAlignment: yup.string(),
  })
  .transform(value => ({
    statName: value.stat_name,
    pillText: value.pill_text,
    score: value.score,
    circleFillColor: value.circle_fill_color || undefined,
    circleBackgroundColor: value.circle_background_color || undefined,
    pillColor: value.pill_color || undefined,
    mobileAlignment: value.mobile_alignment,
    desktopAlignment: value.desktop_alignment,
  }));
